(function ($) {
    var btnClass = '.video-play-button';
    $(document).on('click', btnClass, function (e) {
        e.preventDefault();
        var videoSrc = $(this).attr('href'), video_id, ampersandPosition;
        if (videoSrc.indexOf("watch") > 0) {
            video_id = videoSrc.split("v=")[1];
            ampersandPosition = video_id.indexOf("&");
            if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition);
            }
            videoSrc = "https://youtube.com/embed/" + video_id;
        } else if (videoSrc.indexOf("youtu.be") > 0) {
            video_id = videoSrc.split("e/")[1];
            ampersandPosition = video_id.indexOf("&");
            if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition);
            }
            videoSrc = "https://youtube.com/embed/" + video_id;
        }
        $('.video-overlay iframe').attr('src', videoSrc);
        $('.video-overlay').addClass('active');
    });
    $(document).on('click keydown', function (e) {
        var clickClass = e.target;
        if ($(clickClass).hasClass('video-overlay') || $(clickClass).hasClass('close') || $(clickClass).hasClass('video-wrap') || $(clickClass).hasClass('container')) {
            $('.video-overlay').removeClass('active');
            $('.video-overlay iframe').attr('src', '');
        } else if (e.key == 'Escape') {
            $('.video-overlay').removeClass('active');
            $('.video-overlay iframe').attr('src', '');
        }
    });

    // $(window).on('load resize', setVideoBoxDimesnions);

    // function setVideoBoxDimesnions() {
    //     if ($('.video-overlay .video-wrap').length) {
    //         if ($(window).width() < 1025) {
    //             var videoBoxWidth = $('.video-overlay .container').width();
    //             var videoBoxHeight = (videoBoxWidth / 16) * 9;

    //             if ((videoBoxHeight + 100) > $(window).height()) {
    //                 videoBoxHeight = $('.video-overlay').height();
    //                 videoBoxWidth = (videoBoxHeight / 9) * 16;
    //             }

    //             $('.video-overlay .video-wrap').css({
    //                 width: videoBoxWidth + 'px',
    //                 height: videoBoxHeight + 'px',
    //             });
    //             var windowWidth = $(window).width();
    //             if (windowWidth >= 1200) {
    //                 if ($(window).height() >= 776) {
    //                     $('.video-overlay .video-wrap').css({"height": "620px"});
    //                 }
    //             }
    //         }
    //     }
    // }
})(jQuery);